export default __webpack_public_path__ + "static/media/map-pin-red.6fbc61f8.svg";